"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var metrics_engine_1 = require("@tableau/metrics-engine");
exports.isSingleNumberMetric = function (data) {
    if (typeof data === 'number') {
        return true;
    }
    return data ? data.length <= 1 : true;
};
exports.getBAN = function (data, timestamp) {
    if (timestamp === void 0) { timestamp = new Date(); }
    return typeof data === 'number' ? { measure: data, timestamp: timestamp } : metrics_engine_1.getLatestValue(data);
};
exports.defaultComparisonFor = function (dateTrunc) { return ({
    dateTrunc: dateTrunc,
    compareTo: dateTrunc,
    numberOfPeriods: 1,
    message: '',
}); };
//# sourceMappingURL=utils.js.map